<script>
    export let contact;
    export let isSmallScreen;
    export let isMediumScreen;
    export let isLargeScreen;
    console.log(contact);
</script>

{#if isSmallScreen}
    <div data-type="contact" class="py-4 grid grid-cols-8 justify-center">
        <div class="
            flex
            justify-items-start
            items-center
            col-span-4
            px-2"
        >
            {contact.vorname}
            {contact.nachname}
        </div>
        <div class="col-span-4">
            <div class="text-center">{contact.handynummer}</div>
            <div class="text-slate-400 text-center">{contact.privatnummer}</div>
        </div>
    </div>
{:else if isMediumScreen}
    <div data-type="contact" class="pl-8 py-4 grid grid-cols-7 justify-items-start">
        <div class="
            flex
            justify-items-start
            items-center
            col-span-3
            text-left"
        >
            {contact.vorname}
            {contact.nachname}
        </div>
        <div class="col-span-2 text-center">{contact.handynummer}</div>
        <div class="col-span-2 text-center text-slate-400">
            {contact.privatnummer}
        </div>
    </div>
{:else if isLargeScreen}
    <div data-type="contact" class="pl-8 py-4 grid grid-cols-8 justify-center">
        <div
            class="
                flex
                justify-items-start
                items-center
                col-span-2
                text-center"
        >
            {contact.vorname}
            {contact.nachname}
        </div>
        <div class="col-span-3 text-center">{contact.handynummer}</div>
        <div class="col-span-3 text-center text-slate-400">
            {contact.privatnummer}
        </div>
    </div>
{/if}
